<template>
  <ModalContainer
    :showModal="showModal"
    title="Edit Profile"
    @closeModal="closeModal"
  >
    <AlertDanger v-if="alert_danger" @closeAlertDanger="hideAlertDanger()" :text="alert_text" />
    <AlertSuccess v-if="alert_success" :text="alert_text" />
    <form @submit.prevent="submit">
    <div id="modal-body" class="p-4 h-96 overflow-y-scroll">
      <InputForm
        id="name"
        label="Name"
        input_class="w-full mb-4" 
        type="text"
        v-model="profile.name"
      />
      <InputForm
        label="Email"
        type="text"
        input_class="w-full mb-4" 
        v-model="profile.email"
        :is_disabled="true"
      />
      <InputForm
        id="password"
        label="New Password"
        :type="passwordInputType"
        input_class="w-full mb-4" 
        v-model="profile.password"
      />
      <InputForm
        id="password-confirmation"
        label="Confirm Password"
        :type="passwordInputType"
        input_class="w-full" 
        v-model="profile.password_confirmation"
      />
      <div class="flex items-center gap-2 mt-2">
        <input 
          id="show-password"
          type="checkbox" 
          @change="togglePassword" 
          class="h-5 w-5 rounded-md border-gray-300 bg-transparent text-primary-500 focus:ring-primary-500"
        >
        <small>Show Password</small>
      </div>
    </div>
    <div class="modal-footer pb-6">
      <div class="flex justify-center gap-2">
        <Button
          id="close-modal"
          button_text="Close"
          @click="closeModal"
        />
        <Button
          id="submit"
          button_text="Save Changes"
          button_type="submit"
        />
      </div>
    </div>
    </form>
  </ModalContainer>
</template>

<script>
import ModalContainer from "@/components/modals/ModalContainer.vue";
import InputForm from "../form/InputForm.vue";
import Button from '../buttons/Button.vue';
import AlertDanger from '@/components/alerts/AlertDanger.vue';
import AlertSuccess from '@/components/alerts/AlertSuccess.vue';
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid';
import { mapActions } from 'vuex';

export default {
  name: 'ModalProfile',
  emits: ['closeModal'],
  components: {
    ModalContainer, InputForm, Button, AlertDanger, AlertSuccess,
    EyeIcon, EyeSlashIcon
  },
  data() {
    return {
      showModal: true,
      alert_danger: false,
      alert_success: false,
      alert_text: '',
      passwordInputType: 'password',

      profile: {
        id: this.detailUser?.id,
        name: this.detailUser?.name,
        email: this.detailUser?.email,
        password: '',
        password_confirmation: ''
      }
    };
  },
  created() {
    this.profile.id = this.detailUser?.id;
    this.profile.name = this.detailUser?.name;
    this.profile.email = this.detailUser?.email;
  },
  computed: {
    detailUser() {
      return this.$store.state.detail_user.detail_user;
    },
  },
  methods: {
    ...mapActions('detail_user', ['updateUser']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },
    togglePassword(event) {
      this.passwordInputType = event.target.checked ? 'text' : 'password';
    },
    async submit(){
      if(this.profile.password != this.profile.password_confirmation){
        this.alert_danger = true;
        this.alert_text = "Password and Confirm Password must be the same!";
        return;
      }

      try {
        if(this.profile.password && this.profile.password_confirmation) {
          await this.updateUser(this.profile);
          localStorage.removeItem('auth_token');
          this.$router.push('/');
        }
        // Update Without Password
        else {
          const { password, password_confirmation, ...profileWithoutPassword } = this.profile;
          this.profile = profileWithoutPassword;
          await this.updateUser(this.profile);
        }

        this.alert_success = true;
        this.alert_text = 'Profile updated successfully!';
        setTimeout(() => {
          this.alert_success = false;
          this.alert_text = '';
        }, 1500);
      }
      catch(error){
        console.error(error)
        this.alert_danger = true;
        this.alert_text = 'Failed update profile!' + error;
      }
    },
    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = '';
    },
  },
};
</script>